module.exports = __webpack_public_path__ + "static/img/title_icon.98c6a7cf.png";